import React from 'react';
import { Box } from '@chakra-ui/react';
import styled from 'styled-components';
import { getEtherscanLink, formatAddress } from '../../../utils/helper';

const TDItem = styled.td`
  border-bottom: 2px solid var(--card-color) !important;
  padding: 4px 10px;
`;

export default function RewardSchema({ item, rank }) {
  return (
    <tr>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          <a href={getEtherscanLink(56, item.address, 'address')} target='bank'>
            {formatAddress(item.address)}
          </a>
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {item.namePool}
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {item.namePool}
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {item.namePool}
        </Box>
      </TDItem>
    </tr>
  );
}
